import {
  ListItemButton,
  Stack,
  Typography,
  TypographyProps,
  useTheme,
} from '@mui/material';
import {FontIcon} from '@resurs-internal/mui';
import React, {useState} from 'react';
import {useIsTouchDevice, useTranslate} from '../../hooks';
import {snackbar} from '../../services/snackbar';

export interface CopyTextProps extends TypographyProps {
  value: string | undefined;
  copy?: string;
}

export const CopyText: React.FC<CopyTextProps> = ({value, copy}) => {
  const theme = useTheme();
  const translate = useTranslate();
  const touch = useIsTouchDevice();
  const [isHover, setIsHover] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const onCopy = async () => {
    if (!copy?.length && !value?.length) return;
    await navigator.clipboard.writeText(copy ?? value ?? '');
    snackbar.success(translate('common.copy.success'));
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 1500);
  };

  return (
    <Stack flexDirection={'row'} alignItems={'center'}>
      <ListItemButton
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        sx={{
          marginLeft: -1,
          paddingX: 1,
          paddingY: 0.5,
          borderRadius: 0.5,
          ...(isHover && {
            backgroundColor: theme.palette.grey['100'],
          }),
          ...(isCopied && {
            borderColor: theme.palette.info.main,
          }),
        }}
        onClick={onCopy}>
        {value}
      </ListItemButton>
      {(isHover || touch.isTouch || isCopied) && (
        <FontIcon
          icon={['far', 'copy']}
          size={'sm'}
          style={{
            marginLeft: theme.spacing(0.5),
            marginRight: theme.spacing(0.5),
            color: isCopied
              ? theme.palette.info.main
              : theme.palette.grey['600'],
          }}
        />
      )}
      {isCopied && (
        <Typography variant={'caption'} sx={{color: theme.palette.info.main}}>
          {translate('common.copied')}
        </Typography>
      )}
    </Stack>
  );
};
